<template>
  <div ref="filter-item">
    <DpplTreeselect
      v-model="treeselectModel"
      :async="field.async"
      :options="field.options"
      :async-url="field.asyncUrl"
      :placeholder="col === 'col2' ? 'Select custom filter' : `Select ${getFieldFormattedLabel(field.label)}`"
      :label="field.label"
      show-select-all
      :max-height="200"
      @add-snackbar="$emit('add-snackbar', $event)"
    />
  </div>
</template>

<script>
import DpplTreeselect from '@/components/datapeople/DpplTreeselect.vue';

export default {
  name: 'FilterModalItem',
  components: {
    DpplTreeselect,
  },
  props: {
    field: { type: Object, default: () => ({}) },
    col: { type: String, default: '' },
  },
  emits: ['set-temp-filters', 'add-snackbar'],
  computed: {
    treeselectModel: {
      get() {
        return this.field.value;
      },
      set(value) {
        this.$emit('set-temp-filters', { value, index: this.field.index });
      },
    },
  },
  methods: {
    getFieldFormattedLabel(label) {
      if (label === 'JobNav Score') return 'JobNav score';
      return label.toLowerCase();
    },
  },
};
</script>
